/* =========================
   Interfaces
========================= */

import { apiAxios } from "./api-config/apiConfig";

export interface Distance {
  activity: string;
  distance: number;
}

export interface FitbitActivityData {
  caloriesOut: number;
  activityCalories: number;
  caloriesBMR: number;
  activeScore: number;
  steps: number;
  sedentaryMinutes: number;
  lightlyActiveMinutes: number;
  fairlyActiveMinutes: number;
  veryActiveMinutes: number;
  distances: Distance[];
  marginalCalories: number;
  heartRateZones: any[];
}

export interface SleepLevelData {
  dateTime: string;
  level: string;
  seconds: number;
}

export interface SleepSummaryItem {
  count: number;
  minutes: number;
}

export interface SleepLevels {
  data: SleepLevelData[];
  summary: {
    asleep: SleepSummaryItem;
    awake: SleepSummaryItem;
    restless: SleepSummaryItem;
  };
}

export interface FitbitSleepData {
  dateOfSleep: string;
  duration: number;
  efficiency: number;
  startTime: string;
  endTime: string;
  infoCode: number;
  isMainSleep: boolean;
  levels: SleepLevels;
  logId: number;
  minutesAfterWakeup: number;
  minutesAwake: number;
  minutesAsleep: number;
  minutesToFallAsleep: number;
  logType: string;
  timeInBed: number;
  type: string;
}

export interface FitbitWaterData {
  dateTime: string;
  value: number;
}

export interface FitbitResponseData {
  fitbitActivityData: FitbitActivityData;
  fitbitSleepData: FitbitSleepData[];
  fitbitWaterData: FitbitWaterData[];
}

export interface FitbitApiResponse {
  status: boolean;
  data: FitbitResponseData;
}

export interface FitbitRequestBody {
  token: string;
  date: string;
}

/* =========================
   API Call
========================= */

export const fetchFitbitData = async (
  body: FitbitRequestBody,
): Promise<FitbitApiResponse> => {
  const response = await apiAxios.post("/auth/fitbit", body);
  return response.data;
};
